import React from 'react';
import { EmptyAttachmentsIcon } from '@icons';

interface EmptyTabStateProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

const EmptyTabState: React.FC<EmptyTabStateProps> = ({
  title,
  subtitle,
  children
}) => (
  <div className="py-25">
    <div className="flex flex-col items-center justify-center gap-6 py-8 text-center">
      <EmptyAttachmentsIcon />
      <p className="text-xl font-semibold text-darkGrey">{title}</p>
      {subtitle && (
        <p className="text-sm font-normal leading-3 text-grey">{subtitle}</p>
      )}
      {children}
    </div>
  </div>
);

export default EmptyTabState;
